<template>
	<div class="wrapper">
		<div>
			<div id="countDown">
				<div class="countDownWrapper">
					<div class="timeRemain">支付剩余时间</div>
					<Timer :expireTime="expireTime" :onTimerExpired="onTimerExpired" />
				</div>
			</div>
			<div class="shouldPay">
				<div class="orderCover">
					<img :src="pageData.cover" alt="" class="orderCoverImg">
				</div>
				<div class="orderDesc">
					<div class="orderTitle">{{pageData.title}}</div>
					<div class="payNumWrapper">
						<span class="coinType">
							￥
							<span class="payNum">{{pageData.originalPrice}}</span>
						</span>
					</div>
				</div>
			</div>
			<div class="phoneAreaWrapper">
				<div class="title">学习账号</div>
				<div class="inputWrapper">
					<div class="inputItem">
						<span class="inputText">手机</span>
						<input type="text" v-model="phone" placeholder="请输入手机号" name="phone">
					</div>
					<div class="inputItem">
						<span class="inputText">验证码</span>
						<input type="text" v-model="smsCode" placeholder="请输入验证码" name="phone">
						<SmsCodeButton :buttonClick="getSmsCode" ref="smsCodeButton" />
					</div>
				</div>
			</div>
			<div class="paymentTypeWrapper">
				<div class="thirdPart">
					<div class="title">支付方式</div>
					<!-- <div class="thirdPartText">
						<span>还需支付：</span>
						<span class="thirdPartPayNum">{{pageData.thirdPartPayNum}}巢币</span>
					</div> -->
				</div>
				<div class="paymentTypeItem" @click="payTypeItemClick('wechat')">
					<div class="typeIcon">
						<img src="@/assets/image/payment/wechat_pay.png" alt="">
					</div>
					<div class="payInfo">
						<span class="typeText">微信支付</span>
						<img class="checkIcon" v-if="thirdPartPayType == 'wechat'" src="@/assets/image/payment/selection.png" alt="">
						<div class="checkInactive" v-else></div>
					</div>
				</div>
				<div class="paymentTypeItem" v-if="!isInWx" @click="payTypeItemClick('alipay')">
					<div class="typeIcon">
						<img src="@/assets/image/payment/alipay.png" alt="">
					</div>
					<div class="payInfo">
						<span class="typeText">支付宝支付</span>
						<img class="checkIcon" v-if="thirdPartPayType == 'alipay'" src="@/assets/image/payment/selection.png" alt="">
						<div class="checkInactive" v-else></div>
					</div>
				</div>
			</div>
		</div>
		<div class="rightsWrapper">
			<div class="rightsText">
				如支付即表示您同意
				<span class="rightsLinkText" @click="jumpToRights('emea')">《电巢培训服务协议》</span>、
				<span class="rightsLinkText" @click="jumpToRights('secret')">《隐私协议》</span>
			</div>
		</div>
		<div class="footer">
			<div class="totalTextWrapper">
				<span class="totalText">需付款：</span>
				￥
				<span class="payNum">{{pageData.originalPrice}}</span>
			</div>
			<div id="payButton" @click="pay">立即支付</div>
		</div>
		<div id="messageBox" :style="`display:${showMsg ? 'block' : 'none'}`">{{errMsg}}</div>
		<div id="qrcodeBox" @click="hideQRCodeBox" :style="`display:${showQRCodeBox ? 'block' : 'none'}`">
			<img :src="QRCodeUrl" alt="" />
		</div>
	</div>
</template>

<script>
import utils from '@/utils/utils'
import WxPay from '@/utils/wxpay'
import {pagehost} from '@/utils/http'
import Timer from './Timer'
import SmsCodeButton from './SmsCodeButton'

// 头条
var _baq;
(function(r,d,s){
	r._tt_config=true;
	_baq=(r._baq=r._baq||[]);
	_baq.methods=["track","off","on"];
  _baq.factory=function(method){
		return function(){
			var args=Array.prototype.slice.call(arguments);
			args.unshift(method);
			_baq.push(args);
			return _baq
		}
	};
	for(var i=0;i<_baq.methods.length;i++){
		var key=_baq.methods[i];
		_baq[key]=_baq.factory(key)
	}
	_baq.load=function(){
		var js,fjs=d.getElementsByTagName(s)[0];
		js=d.createElement(s);
		js.src="https://analytics.oceanengine.com/api/v2/js/sdk";
		fjs.parentNode.insertBefore(js,fjs)
	};
  _baq.load();
	if(_baq.invoked){
		return
	}
	_baq.invoked=true;
	_baq.track("pageview")
})(window,document,"script");

export default {
	data(){
		return {
			order: localStorage.getItem('tradeSn') || '',
			activityId: this.$route.query.activity_id || '',
			openid: this.$route.query.openid || '',
			succeedUrl: decodeURIComponent(this.$route.query.succeed_url) || '',
			pageData: {},
			thirdPartPayType: 'wechat',  /* wechat, alipay*/
			finalAmount: '',
			expireTime: (new Date().getTime()/1000|0) + 43200,
			isOrderValid: true,
			showQRCodeBox: false,
			QRCodeUrl: '',
			showMsg: false,
			errMsg: '',
			phone: '',
			smsCode: '',
			buttonValid: true,
			isInWx: utils.browserChecker.isWx(),
			isInPc: !(utils.browserChecker.isIOS() || utils.browserChecker.isAndroid()),
			channel: this.$route.query.channel
		}
	},
	created(){
		this.getOrderInfo()
		this.wx = new WxPay()
		/*如果当前页面存在订单，则先查询订单状态*/
		this.order && this.polling()
	},
	destroyed(){
		this.intervalPolling && clearInterval(this.intervalPolling)
	},
	methods: {
		getOrderInfo(){
			this.$http('activity/Info', {
				params: {
					activity_id: this.activityId
				}
			}).then(res => {
				if(res.code >= 0){
					let data = res.data
					this.pageData = {
						title: data.title,
						originalPrice: data.cash_price,
						cover: data.cover,
					}
					this.finalAmount = data.price
				}else{
					this.showMessage(res.msg)
				}
			})
		},
		pay(){
			/*头条*/
			_baq.track("form", {assets_id: "1704505317702723", phone: this.phone});
			if(this.check()){
				if(this.isInPc && this.thirdPartPayType == 'wechat' && this.QRCodeUrl){
					/*如果在pc端且已生成支付二维码，则直接弹出二维码不再下单*/
					this.showQRCodeBox = true
				}else{
					this.generateOrder().then(res => {
						if(res.code >= 0){
							if(!res.data.need_pay){
								/*b站上报*/
								window.bilicm.mbase.report_data()
								/*头条*/
								_baq.track("form", {
									assets_id: "1704505317702723",
									phone: this.phone
								})
								window.location.replace(this.succeedUrl)
							}else{
								this.payOrder(res.data)
							}
						}else{
							this.showMessage(res.msg)
							if(res.code == -21){
								setTimeout(() => {
									window.location.replace(this.succeedUrl)
								}, 2000)
							}
						}
					})
				}
			}
		},
		generateOrder(){
			// project_id: this.$route.query.pid,
			return this.$http('activity/activityRegister', {
				params: {
					activity_id: this.activityId,
					phone: this.phone,
					sms_code: this.smsCode,
					// project: this.$route.query.project,
					channel: this.channel,
					project_id: this.$route.query.project,
				}
			})
		},
		payOrder(snData){
			this.order = snData.order_sn
			let payTypeMap = {
				wechat: 'WechatPay_MWeb',
				alipay: 'Alipay_LegacyWap',
				elecnest: 'Coin'
			}
			if(this.isInPc){
				/*如果不是在ios或android内，则默认是pc内打开*/
				payTypeMap.wechat = 'WechatPay_Native'
				payTypeMap.alipay = 'Alipay_LegacyExpress'
			}else if(this.isInWx){
				/*若是手机微信内打开，则微信支付时转用jsApi支付*/
				payTypeMap.wechat = 'WechatPay_Js'
			}
			if(this.thirdPartPayType == 'alipay'){
				/*如果是支付宝支付，那么只能在当前上报数据给b站，之后跟踪不到*/
				window.bilicm.mbase.report_data()
			}
			this.$http('activity/dopay', {
				params: {
					gateway: payTypeMap[this.thirdPartPayType],
					type: 'purchase',
					order_sn: this.order,
					amount: this.finalAmount,
					openid: this.openid,
					succeed_url: this.$route.query.succeed_url || '',
				}
			}).then(res => {
				if(res.code >= 0){
					let data = res.data
					if(data.status == 'paid'){
						localStorage.removeItem('tradeSn')
						clearInterval(this.intervalPolling)
						this.showMessage('支付成功')
						/*b站上报*/
						window.bilicm.mbase.report_data()
						/*头条*/
						_baq.track("form", {assets_id: "1704505317702723", phone: this.phone})
						window.location.replace(this.succeedUrl)
					}else{
						data.tradeSn && localStorage.setItem('tradeSn', data.tradeSn)
						switch(this.thirdPartPayType){
							case 'wechat': {
								if(this.isInPc){
									/*如果是网页用微信支付，则弹起支付二维码*/
									this.QRCodeUrl = data.qrcodeUrl
									this.showQRCodeBox = true
									this.polling()
								}else if(this.isInWx){
									/*如果是微信内支付，则调用jsapi唤起微信支付*/
									this.wx.pay(data, this.polling.bind(this))
								}else{
									this.polling()
									location.href = data.mwebUrl
								}
								break
							}
							case 'alipay': {
								if(this.isInPc){
									/*如果是网页用支付宝支付，则跳转支付二维码*/
									location.href = data.qrcodeUrl
								}else{
									setTimeout(() => {
										document.write(data.paymentHtml)
									}, 500)
								}
								break
							}
						}
					}
				}else{
					this.showMessage(res.msg)
				}
			})
		},
		check(){
			if(this.isOrderValid){
				if(!utils.checkPhone(this.phone)){
					this.showMessage('请填写有效的手机号码')
					return false
				}else if(utils.checkEmpty(this.smsCode)){
					this.showMessage('请填写验证码')
					return false
				}else{
					return true
				}
			}else{
				this.showMessage('该订单已过期，请重新下单')
				return false
			}
		},
		polling(){
			let tradeSn = localStorage.getItem('tradeSn')
			this.intervalPolling && clearInterval(this.intervalPolling)
			this.intervalPolling = setInterval(() => {
				if(this.isOrderValid && tradeSn){
					this.$http('activity/getTradeStatus', {
						params: {trade_sn: tradeSn}
					}).then(res => {
						if(res.code >= 0 && res.data.status == 'paid'){
							localStorage.removeItem('tradeSn')
							clearInterval(this.intervalPolling)
							this.showMessage('支付成功')
							/*b站上报*/
							window.bilicm.mbase.report_data()
							/*头条*/
							_baq.track("form", {assets_id: "1704505317702723", phone: this.phone})
							setTimeout(() => {
								window.location.replace(this.succeedUrl)
							}, 1000)
						}
					})
				}else{
					clearInterval(this.intervalPolling)
				}
			}, 1500)
		},
		getSmsCode(){
			if(utils.checkPhone(this.phone)){
				this.$http('Registered/getPhoneSmsCode', {
					params: utils.cso({
						phone_head: 86,
						phone: this.phone,
						type: 4,
						client: 'H5'
					})
				}).then(res => {
					if(res.code >= 0){
						this.$refs.smsCodeButton.reset()
						this.$refs.smsCodeButton.countdown(120)
						this.showMessage('验证码发送成功，请注意查收')
					}else{
						this.showMessage(res.msg)
					}
				})
			}else{
				this.showMessage('请填写有效的手机号码')
			}
		},
		payTypeItemClick(type){
			this.thirdPartPayType = type
		},
		jumpToRights(type){
			switch(type){
				case 'emea': {
					location.href = pagehost + '/h5/protocol/emeaProtocol.html?temp=' + new Date()
					break
				}
				case 'secret': {
					location.href = pagehost + '/vip/privacyPolicy.html?temp=' + new Date()
					break
				}
			}
		},
		onTimerExpired(){
			this.isOrderValid = false
		},
		hideQRCodeBox(){
			this.showQRCodeBox = false
		},
		showMessage(msg){
			this.errMsg = msg
			this.showMsg = true
			setTimeout(() => {
				this.showMsg = false
			}, 5000)
		}
	},
	components: {
		Timer: Timer,
		SmsCodeButton: SmsCodeButton
	}
}
</script>

<style scoped>
img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
input{
	border: none;
	outline: none;
}
.title{
	font-size: 18px;
	color: #1d2023;
	font-weight: 500;
}
.coinType{
	font-size: 12px;
	color: #e50120;
}
.payNum{
	font-size: 24px;
	margin-left: 3px;
	font-weight: 500;
}

.wrapper{
	position: relative;
	margin: 0;
	padding: 0;
	min-height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background-color: #f7f8f8;
	padding-bottom: 50px;
	box-sizing: border-box;
}
.header{
	position: fixed;
	top: 0;
	width: 100%;
	height: 75px;
	box-sizing: border-box;
	padding: 15px;
	padding-top: 35px;  /* 15+20 */
	background-color: #fff;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.headerTitle{
	text-align: center;
}
.backIconWrapper{
	position: absolute;
	top: 37px;  /* 35+2 */
	left: 15px;
	width: 11px;
	height: 20px;
	padding-right: 20px;
}

.countDownWrapper{
	padding: 15px;
	background-color: #fff;
}
.timeRemain{
	margin: 13px 0;
	text-align: center;
	font-size: 11px;
	color: #606972;
}

.shouldPay{
	display: flex;
	align-items: center;
	padding: 15px;
	background-color: #fff;
}
.orderCover{
	width: 100px;
	height: 69px;
	background-color: #e3e3e3;
	border-radius: 5px;
	overflow: hidden;
	flex-shrink: 0;
}
.orderCoverImg{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.orderDesc{
	flex: 1;
	margin-left: 12px;
}
.orderTitle{
	margin: 13px 0;
	font-size: 14px;
	overflow: hidden;
}
.payNumWrapper{
	text-align: right;
}

.benefitsSection{
	margin-top: 10px;
}
.vipCouponSection{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	background-color: #fff;
}
.couponSection{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	background-color: #fff;
}
.couponText{
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #3f454b;
}
.arrRightIcon{
	width: 13px;
	height: 13px;
	margin-left: 5px;
}

.coinPaySection{
	margin-top: 10px;
	padding: 15px 15px 0 15px;
	background-color: #fff;
}
.coinPaySection > .title > span:first-child{
	margin-left: 5px;
}
.coinPayText{
	font-size: 12px;
	color: #606972;
}
.coinPayLink{
	font-size: 12px;
	color: #4a90e2;
}
.coinPayNum{
	margin-right: 15px;
	font-size: 14px;
	color: #e50120;
	line-height: 20px;
	vertical-align: top;
}

.thirdPart{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.thirdPartText{
	font-size: 14px;
	color: #1d2023;
}
.thirdPartPayNum{
	color: #e50120;
}

.phoneAreaWrapper{
	margin-top: 10px;
	padding: 15px 15px 0 15px;
	background-color: #fff;
}
.inputItem{
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 16px;
	color: #606972;
	line-height: 2;
	padding: 15px 0;
}
.inputText{
	white-space: nowrap;
}
.inputItem input{
	flex: 1;
	margin: 0 5px;
	padding: 5px;
	color: #606972;
}
.inputItem input::placeholder{
	color: #A6A9BA;
}
.smsCodeButton{
	display: inline-block;
	padding: 0 5px;
	font-size: 14px;
	color: #f00;
	line-height: 1.5;
	white-space: nowrap;
	border: 1px solid #f00;
	border-radius: 20px;
	cursor: pointer;
}

.paymentTypeWrapper{
	margin-top: 10px;
	padding: 15px 15px 0 15px;
	background-color: #fff;
}
.paymentTypeItem{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.typeIcon{
	width: 20px;
	height: 20px;
	flex-shrink: 0;
}
.payInfo{
	flex: 1;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-left: 10px;
	padding: 15px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.paymentTypeItem:last-child .payInfo{
	border-bottom: none;
}
.typeText{
	font-size: 16px;
	color: #1d2023;
}
.recommendIcon{
	width: 25px;
	height: 15px;
	object-fit: contain;
}
.checkIcon{
	width: 20px;
	height: 20px;
	object-fit: contain;
}
.checkInactive{
	width: 18px;
  height: 18px;
  border: 1px solid #979797;
  border-radius: 50% 50%;
}
.couponWrapper{
	margin-top: 10px;
	padding: 15px;
	background-color: #fff;
}
#couponInput{
	flex: 1;
	min-height: 40px;
	font-size: 14px;
	background-color: #f8f9fb;
	border: none;
}
#useCouponButton{
	width: 60px;
	height: 40px;
	line-height: 40px;
	margin-left: 12px;
	text-align: center;
	color: #fff;
	background-color: #f00;
	border-radius: 5px;
}
.rightsWrapper{
	flex-shrink: 0;
	margin-top: 15px;
}
.remarkArea{
	margin: 10px 5px;
	font-size: 12px;
	color: #3f454b;
}

.rightsText{
	margin: 15px 20px;
	font-size: 12px;
	text-align: center;
	color: #3f454b;
}
.rightsLinkText{
	color: #4a90e2;
	cursor: pointer;
}
.footer{
	position: absolute;
	bottom: 0;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 15px;
	padding-left: 15px;
	background-color: #fff;
	box-sizing: border-box;
}
.totalTextWrapper{
	display: flex;
	align-items: center;
	font-size: 12px;
	color: #e50120;
}
.totalText{
	margin-right: 5px;
	font-size: 14px;
	color: #3f454b;
}
#payButton{
	width: 130px;
	height: 50px;
	line-height: 50px;
	font-size: 18px;
	text-align: center;
	color: #fff;
	background-color: #f00;
	background-image: linear-gradient(to right, #fe405a, #e50101);
}

#messageBox{
	display: none;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 3px 15px;
	font-size: 14px;
	color: #fff;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 5px;
	z-index: 10;
}
#qrcodeBox{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	text-align: center;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 10;
}
#qrcodeBox img{
	width: 50%;
	height: 50%;
	margin-top: 20%;
}
</style>
